<template>
  <div>
    <MemberLayout>
      <div class="container">
        <div class="card my-3">
          <div class="card-header bg-primary text-white">加購清單</div>
          <ul class="list-group list-group-flush">
            <li
              v-for="(product, i) in additionalSets"
              :class="[
                'list-group-item',
                { 'd-none': product.lockedForHasOtherSelected },
              ]"
              :key="`${product.data.CODE}_${i}`"
            >
              <div class="row">
                <div class="col-4">
                  <img
                    :src="`http://fordays-backend-official.herokuapp.com/assets/product_images/${product.data.ICON}`"
                    class="w-100"
                    alt=""
                  />
                </div>
                <div class="col-8">
                  <h4 class="product-name">{{ product.data.NAME }}</h4>
                  <h5 class="product-price">
                    $ {{ product.data.UNITPRICE }} NTD
                  </h5>
                </div>
                <div class="col-12 my-3">
                  <div
                    v-if="product.isChecked && product.REPEATABLE == 1"
                    class="form-group"
                  >
                    <select
                      @change="
                        onAmountChange($event, {
                          product: product,
                          itemIndex: i,
                        })
                      "
                      class="form-control"
                      name=""
                      id=""
                    >
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                    </select>
                  </div>
                  <div
                    v-if="product.isChecked && product.REPEATABLE == 0"
                    class="form-group"
                  >
                    <select
                      @change="
                        onAmountChange($event, {
                          product: product,
                          itemIndex: i,
                        })
                      "
                      class="form-control"
                      name=""
                      id=""
                    >
                      <option :value="product.DEFAULTNET">
                        {{ product.DEFAULTNET }}
                      </option>
                    </select>
                  </div>
                  <button
                    v-if="!product.lockedForHasOtherSelected"
                    :class="[
                      'btn',
                      { 'btn-primary': !product.isChecked },
                      { 'btn-warning': product.isChecked },
                      'btn-block',
                    ]"
                    @click="
                      pressSelectProductBtn({
                        product: product,
                        itemIndex: i,
                        isSelect: !product.isChecked ? true : false,
                      })
                    "
                  >
                    <span v-if="!product.isChecked">選取品項</span>
                    <span v-if="product.isChecked">品項已選取</span>
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div>
          <h3>已選取商品金額： ${{ additionalSetSummationPrice() }}</h3>
        </div>
        <div v-if="additionalSetSummationPrice() > 0" class="my-3">
          <button class="btn btn-warning btn-block" @click="navigateToNext">
            下一步
          </button>
        </div>
      </div>
    </MemberLayout>
  </div>
</template>
<script>
import moment from "moment";
import MemberLayout from "../../components/member/MemberLayout";
import {
  getCurrentUser,
  getBusinessMonth,
  getUserAdditionalSellsets,
} from "../../api/fordaysHelpers";
export default {
  name: "AdditionalOrderScreen",
  components: {
    MemberLayout,
  },
  data() {
    return {
      additionalSets: [],
      isLoaded: false,
      cart: {
        SEQ: null,
        user: {},
        items: {},
        type: "additional",
        // 購買模式：(1=定期購買、2=加購)
        SALESTYPE: 2,
        updatedAt: new Date(),
        // 是否走完付款流程(可能成功與失敗)
        isFinishedPayment: false,
        // 付款流程完成於
        paymentFinishedAt: null,
        // 寫入Fordays是否有出錯
        fordaysJsellallinError: 0,
        // 作業系統
        deviceOS: window.navigator.platform,
        deviceOSVersion: window.navigator.appVersion,
        // 狀態
        // 'notPay' 還沒付款
        // 'payError' 付款失敗
        // '3DPayError' 3D付款失敗
        // 'paySuccess' 付款成功
        status: "notPay",
        // 3D Tappay付款錯誤物件
        errThreeDomain: {},
        // 是否可被公開取得(Secure Rule)
        isPublic: true,
      },
    };
  },
  methods: {
    navigateToNext() {
      const vm = this;
      const { cart, additionalSets } = vm;
      const newCart = cart;
      newCart.createdAt = new Date();
      newCart.updatedAt = newCart.createdAt;
      vm.isLoaded = false;
      // push 一定要有name才能帶 params
      let itemCount = 1;
      additionalSets.forEach((set) => {
        if (set.isChecked) {
          newCart.items[itemCount] = set;
          itemCount += 1;
        }
      });
      vm.$router.push({
        name: "OrderSummationScreen",
        params: { cart: newCart },
      });
    },
    onAmountChange($event, obj) {
      const vm = this;
      const amount = parseInt($event.target.value);
      const { itemIndex } = obj;
      const additionalSets = [...vm.additionalSets];
      additionalSets[itemIndex].amount = amount;
      vm.additionalSets = additionalSets;
    },
    pressSelectProductBtn(obj) {
      const vm = this;
      const { itemIndex, isSelect } = obj;
      const additionalSets = [...vm.additionalSets];
      if (isSelect) {
        additionalSets[itemIndex].isChecked = true;
        additionalSets[itemIndex].amount = additionalSets[itemIndex].DEFAULTNET;
      } else {
        additionalSets[itemIndex].isChecked = false;
        additionalSets[itemIndex].amount = 0;
      }
      additionalSets.forEach((set, i) => {
        // 現在被點到的按鈕
        if (i == itemIndex) {
          set.lockedForHasOtherSelected = false;
        } else {
          // 其他的按鈕
          // 在被點到的按鈕是要被選的
          if (isSelect) {
            set.lockedForHasOtherSelected = true;
          } else {
            // 在被點到的按鈕是要取消選曲
            set.lockedForHasOtherSelected = false;
          }
        }
      });

      vm.additionalSets = additionalSets;
    },
    additionalSetSummationPrice() {
      const vm = this;
      const { additionalSets } = vm;
      let additionalSetSummationPrice = 0;
      additionalSets.forEach((set) => {
        if (set.isChecked) {
          additionalSetSummationPrice += set.data.UNITPRICE * set.amount;
        }
      });
      return additionalSetSummationPrice;
    },
  },
  mounted() {
    const vm = this;
    async function fetchData() {
      const { cart } = vm;
      const user = await getCurrentUser();
      if (user.ACT == 0) {
        vm.$router.push("/member/order-main");
        return;
      }
      const businessMonth = getBusinessMonth();
      const allSets = await getUserAdditionalSellsets(vm, user, businessMonth);
      allSets.forEach((set) => {
        set.isChecked = false;
        set.amount = 0;
        // 因為已經選到其他品項而被鎖住
        set.lockedForHasOtherSelected = false;
      });
      const newCart = { ...cart };
      newCart.user = user;
      newCart.businessMonth = businessMonth;
      newCart.receptDate = moment().format("YYYYMMDD");
      newCart.SEQ = user.SEQ;
      newCart.uid = user.uid;
      vm.cart = newCart;
      vm.additionalSets = allSets;
      vm.isLoaded = true;
    }
    fetchData();
  },
};
</script>
<style lang="scss" scoped>
</style>